import React from 'react'

const isRunningLocally = (process.env.NODE_ENV === 'development'
  && (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost'))

const toDriverDownload = () => {
  if (!isRunningLocally) {
    window.location.replace(`https://${window.location.hostname}/driver_download`)
    return (<div></div>)
  } else
    return (<div>The Driver Download page is unavailable when running PCC locally</div>)
}

const toPrivacyPolicy = () => {
  if (!isRunningLocally) {
    window.location.replace(`https://${window.location.hostname}/privacy_policy`)
    return (<div></div>)
  } else
    return (<div>The Privacy Policy page is unavailable when running PCC locally</div>)
}

const toTermsAndConditions = () => {
  if (!isRunningLocally) {
    window.location.replace(`https://${window.location.hostname}/terms_and_conditions`)
    return (<div></div>)
  } else
    return (<div>The Terms and Conditions page is unavailable when running PCC locally</div>)
}

export {
  toDriverDownload,
  toPrivacyPolicy,
  toTermsAndConditions,
}